module.exports = __webpack_public_path__ + "static/media/Group278.4a170f5e.png";